import React, {useMemo} from 'react';
import {Table, Button, Dropdown, Input, Grid, Icon} from 'semantic-ui-react';
import {useTable, usePagination, useFilters} from 'react-table';
import {pageSizes} from '../../../common/constants/lists';
import {Filter, DefaultColumnFilter} from './transportistTableFilters';

const TransportistTable = ({tableColumns, tableData, editTransportist, transportistSelected,
  handleTransportistValue, getTransportistEditingValue, setTransportistRef, handleTransportistUpdate,
  cancelTransportistUpdate, addTransportist, changeNewTransportistValue, cancelAddTransportist,
  saveNewTransportist, handleDeleteTransportist, showAgenciesModalHandler, validateTransportist}) => {
  const data = useMemo(() => tableData, [tableData]);
  const columns = useMemo(() => tableColumns, []);

  const TablePaginator = ({
    page,
    canPreviousPage,
    pageIndex,
    pageOptions,
    pageSize,
    canNextPage,
    nextPage,
    gotoPage,
    previousPage,
    setPageSize,
  }) => {
    if (page.length) {
      return (
        <Grid className="pagination">
          <Grid.Row>
            <Grid.Column width={4} textAlign="left">
              <Button
                className="navigation-button"
                onClick={() => previousPage()}
                disabled={!canPreviousPage}
                content="Anterior"
              />
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <span>páginas </span>
              <span>
                <Input
                  className="pages-input"
                  type="number"
                  value={pageIndex + 1}
                  min="1"
                  max={pageOptions.length}
                  onChange={(e, {value}) => {
                    const page = value ? Number(value) - 1 : 0;
                    if (page < 1 || page > pageOptions.length) {
                      e.target.value = 1;
                    }
                    gotoPage(page);
                  }}
                />
              </span>{' '}
              <span>de {pageOptions.length}</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="left">
              <Dropdown
                className="page-sizes-selection"
                selection
                upward
                compact
                value={pageSize}
                options={pageSizes}
                onChange={(e, {value}) => {
                  setPageSize(Number(value));
                }}
              />
              <span> filas</span>
            </Grid.Column>
            <Grid.Column width={4} textAlign="right">
              <Button
                className="navigation-button"
                onClick={() => nextPage()}
                disabled={!canNextPage}
                content="Siguiente"
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      );
    }
    return null;
  };

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 5},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    (hooks) => {
      hooks.visibleColumns.push((columns, i) => [
        ...columns.map((column, i) => {
          return {...column,
            'Cell': (item) => {
              return (
                <div key={`body-cell${i}`} style={{'textAlign': 'center'}}>
                  {!transportistSelected(item.row.original) ?
                    <div>{item.value}</div> :
                    <Input fluid className='' value={getTransportistEditingValue(item.cell.column.id)}
                      ref={setTransportistRef}
                      id={item.cell.column.id}
                      onChange={(e, input) => handleTransportistValue(e, input)} />}
                </div>
              );
            },
          };
        }),
        {
          'id': 'editTransportistButton',
          'width': 1,
          'Cell': ({row}) => {
            return (
              <div key={`body-cell${i}`} className='flex end'>
                {!transportistSelected(row.original) ?
                  <>
                    <Icon className='storefront' link size='big'
                      onClick={(e, input) => showAgenciesModalHandler(e, true, row.original)} />
                    <Icon name='pencil' link size='big'
                      onClick={(e, input) => editTransportist(e, row.original)} />
                    <Icon name='trash' link size='big' color='red'
                      onClick={(e) => handleDeleteTransportist(e, true, row.original)} />
                  </> :
                  <>
                    <Icon name='save' color='green' link size='big' disabled={validateTransportist('edit')}
                      onClick={(e, input) => handleTransportistUpdate()} />
                    <Icon name='cancel' color='red' link size='big'
                      onClick={(e, input) => cancelTransportistUpdate()} />
                  </>
                }
              </div>
            );
          },
        },
      ]);
    }
  );

  return (
    <>
      <Table className='interactive' striped compact {...getTableProps()}>
        <Table.Header>
          {headerGroups.map((headerGroup, i) => (
            <Table.Row key={`headers${i}`} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, index) => (
                <Table.HeaderCell
                  key={`title-${index}`}
                  textAlign='center'
                  {...column.getHeaderProps()}
                  width={column.width}
                >
                  {column.render('Header')}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          ))}
          {headerGroups.map((headerGroup, i) => (
            <>
              <Table.Row key={`filters${i}`} id='filters'>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    className={index === 3 || index === 6 ? 'dropdown-header' : ''}
                    textAlign='center'
                  >
                    {<Filter column={column} />}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
              {addTransportist ?
                <Table.Row key={`new-register${i}`} id='new-register'>
                  {headerGroup.headers.map((column, index) => (
                    <Table.HeaderCell
                      style={{'backgroundColor': 'white'}}
                      key={`filter-${index}`}
                      textAlign='center'
                    >
                      {!(column.id === 'editTransportistButton') ?
                        <Input fluid disabled={column.id === 'courierName'}
                          value={addTransportist[column.id] || ''}
                          onChange={(e, input) => {
                            changeNewTransportistValue(e, column, input.value);
                          }}
                        /> :
                        <>
                          <Icon name='save' color='green' link size='big' disabled={validateTransportist()}
                            onClick={(e) => saveNewTransportist(e)} />
                          <Icon name='cancel' color='red' link size='big'
                            onClick={(e) => cancelAddTransportist(e)} />
                        </>
                      }
                    </Table.HeaderCell>
                  ))}
                </Table.Row> : ''
              }
            </>
          ))}
        </Table.Header>
        <Table.Body {...getTableBodyProps()}>
          {!page.length && (
            <Table.Row>
              <Table.Cell colSpan={7} textAlign='center'>
                No hay datos disponibles
              </Table.Cell>
            </Table.Row>
          )}
          {page.length > 0 &&
            page.map((row, i) => {
              prepareRow(row);
              return (
                <Table.Row key={`body-row${i}`} {...row.getRowProps()}>
                  {row.cells.map((cell) => {
                    return (
                      <Table.Cell key={`body-cell${i}`} textAlign='center' {...cell.getCellProps()}>
                        {cell.render('Cell')}
                      </Table.Cell>
                    );
                  })}
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
      <TablePaginator
        page={page}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default TransportistTable;
